import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import OrderPadCreateAndUpdateMain from "Components/OrderPad/OrderPadCreateAndUpdateMain";
// const OrderPadCreateAndUpdateMain = React.lazy(() =>
//   import("Components/OrderPad/OrderPadCreateAndUpdateMain")
// );

const OrderCreateAndUpdate = () => {
  return (
    // <ContainerWrapper>
    <OrderPadCreateAndUpdateMain />
    // </ContainerWrapper>
  );
};

export default OrderCreateAndUpdate;
